module.exports = __webpack_public_path__ + "img/01.f45d0b0f.gif";